import { SegmentMiddlewareT } from './types';
import { getLocation } from '~/utils/window';

/* 
Segment Middleware 
see https://segment.com/docs/connections/sources/catalog/libraries/website/javascript/middleware/
*/

const excludeHomePage = ({ payload, next }: SegmentMiddlewareT) => {
  const { pathname } = getLocation();
  if (payload.obj.type === 'page' && pathname === '/') {
    return;
  }
  next(payload);
};

const blacklistedIDs = [
  '4418510497242893258', // synthetics-checks-synthia
];

const excludeUserById = ({ payload, next }: SegmentMiddlewareT) => {
  if (blacklistedIDs.includes(payload.obj.userId)) {
    return;
  }
  next(payload);
};

// middlewares we want to apply
export const middleware = [excludeHomePage, excludeUserById];
